import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/about/AboutWrapper.jsx");
